import apiClient from '@/services/apiClient';
import type { ApiResponse, PaginatedData } from '@/types/api';
import type { Country, Destination } from '@/types/country';

// ── Country CRUD ────────────────────────────────────────────────────

/** 获取国家列表（公开端点） */
export async function getCountries(params?: Record<string, unknown>) {
  const { data } = await apiClient.get<ApiResponse<PaginatedData<Country>>>(
    '/countries',
    { params },
  );
  return data.data;
}

/** 创建国家 */
export async function createCountry(payload: Record<string, unknown>) {
  const { data } = await apiClient.post<ApiResponse<Country>>(
    '/admin/countries',
    payload,
  );
  return data.data;
}

/** 更新国家 */
export async function updateCountry(
  countryId: number,
  payload: Record<string, unknown>,
) {
  const { data } = await apiClient.put<ApiResponse<Country>>(
    `/admin/countries/${countryId}`,
    payload,
  );
  return data.data;
}

/** 删除国家 */
export async function deleteCountry(countryId: number) {
  const { data } = await apiClient.delete<ApiResponse<null>>(
    `/admin/countries/${countryId}`,
  );
  return data.data;
}

// ── Destination CRUD ────────────────────────────────────────────────

/** 获取目的地列表（公开端点） */
export async function getDestinations(params?: Record<string, unknown>) {
  const { data } = await apiClient.get<
    ApiResponse<PaginatedData<Destination>>
  >('/destinations', { params });
  return data.data;
}

/** 创建目的地 */
export async function createDestination(
  payload: Record<string, unknown>,
) {
  const { data } = await apiClient.post<ApiResponse<Destination>>(
    '/admin/destinations',
    payload,
  );
  return data.data;
}

/** 更新目的地 */
export async function updateDestination(
  destinationId: number,
  payload: Record<string, unknown>,
) {
  const { data } = await apiClient.put<ApiResponse<Destination>>(
    `/admin/destinations/${destinationId}`,
    payload,
  );
  return data.data;
}

/** 删除目的地 */
export async function deleteDestination(destinationId: number) {
  const { data } = await apiClient.delete<ApiResponse<null>>(
    `/admin/destinations/${destinationId}`,
  );
  return data.data;
}
